import React from 'react';
import moment from 'moment';
import { Container, Cell, CellContent, IconWrap, FarolIndicator, Title, Subtitle } from './styles';
import { useHistory } from 'react-router-dom';
import { TbReportMoney } from 'react-icons/tb';
import { BsPrinter } from 'react-icons/bs';
import { BiMessageSquareEdit } from 'react-icons/bi';
import { success, blue, error } from 'styles/colorProvider';
import { formatPlate, formatCurrency } from 'react-data-formatter';
import { Tooltip, IconButton } from '@material-ui/core';

function QuotationItem({ quotation, actionsActive }) {
  const history = useHistory();

  const navigate = async (e) => {
    e.preventDefault();
    history.push({
      pathname: `/cotacao`,
      state: { quotation: quotation.id },
    });
  };

  const navigateToPrint = async (e) => {
    e.preventDefault();
    window.open(`/imprimir-cotacao/${quotation?.id}`);
  };

  const dias = (() => {
    const hoje = moment().startOf('day');
    const vencimento = moment(quotation?.due_at).startOf('day');
    const d = vencimento.diff(hoje, 'days');
    return d < 0 ? 0 : d;
  })();

  const diasDesdeCriacao = quotation?.created_at
    ? moment().startOf('day').diff(moment(quotation.created_at).startOf('day'), 'days')
    : 0;
  const farolColors = { green: '#4caf50', yellow: '#ff9800', red: '#f44336' };
  const farolLabels = {
    green: '1 a 3 dias desde a criação',
    yellow: '4 a 6 dias desde a criação',
    red: '7 ou mais dias desde a criação',
    proposal: 'Cotação convertida em proposta',
  };
  const farolStatus = quotation?.hasProposal
    ? 'proposal'
    : diasDesdeCriacao <= 3
      ? 'green'
      : diasDesdeCriacao <= 6
        ? 'yellow'
        : 'red';
  const farolColor = farolStatus === 'proposal' ? farolColors.green : farolColors[farolStatus];
  const farolLabel = farolStatus === 'proposal' ? farolLabels.proposal : farolLabels[farolStatus];

  const iconColor =
    moment().endOf('day') <= moment(quotation.due_at).endOf('day') && !quotation.hasProposal
      ? blue
      : quotation.hasProposal
        ? success
        : error;

  const cliente = quotation?.userName ?? '—';
  const autor = quotation?.authorName ?? '—';
  const placa = quotation?.vehicle?.plate ? formatPlate(quotation.vehicle.plate) : 'Sem placa';
  const marca = quotation?.vehicleBrand ?? '—';
  const modelo = quotation?.vehicleModel ?? '—';
  const valor = formatCurrency(quotation?.value);
  const criadaEm = quotation?.created_at ? moment(quotation.created_at).format('DD/MM/YYYY') : '—';

  const wrapTooltip = (text, content) =>
    text && String(text).length > 25 ? (
      <Tooltip title={text} placement="top" arrow>
        <span style={{ display: 'block', minWidth: 0, overflow: 'hidden', textOverflow: 'ellipsis' }}>{content}</span>
      </Tooltip>
    ) : (
      content
    );

  return (
    <Container>
      <Cell className="cell-icon" align="center">
        <IconWrap>
          <TbReportMoney size={24} color={iconColor} />
        </IconWrap>
      </Cell>

      <Cell className="cell-cliente">
        <Title>Cliente</Title>
        <CellContent>{wrapTooltip(cliente, <Subtitle>{cliente}</Subtitle>)}</CellContent>
      </Cell>

      <Cell className="cell-autor">
        <Title>Autor</Title>
        <CellContent>{wrapTooltip(autor, <Subtitle>{autor}</Subtitle>)}</CellContent>
      </Cell>

      <Cell className="cell-placa">
        <Title>Placa</Title>
        <CellContent>
          <Subtitle>{placa}</Subtitle>
        </CellContent>
      </Cell>

      <Cell className="cell-marca">
        <Title>Marca</Title>
        <CellContent>{wrapTooltip(marca, <Subtitle>{marca}</Subtitle>)}</CellContent>
      </Cell>

      <Cell className="cell-modelo">
        <Title>Modelo</Title>
        <CellContent>{wrapTooltip(modelo, <Subtitle>{modelo}</Subtitle>)}</CellContent>
      </Cell>

      <Cell className="cell-valor">
        <Title>Valor da cotação</Title>
        <CellContent>
          <Subtitle>{valor}</Subtitle>
        </CellContent>
      </Cell>

      <Cell className="cell-criada">
        <Title>Criada em</Title>
        <CellContent>
          <Subtitle>{criadaEm}</Subtitle>
        </CellContent>
      </Cell>

      <Cell className="cell-farol" align="center">
        <Tooltip title={farolLabel} placement="top" arrow>
          <FarolIndicator color={farolColor} />
        </Tooltip>
      </Cell>

      <Cell className="cell-dias" align="center">
        <Title>Dias</Title>
        <Subtitle>{dias}</Subtitle>
      </Cell>

      <Cell className="cell-actions" align="center">
        {moment().endOf('day') <= moment(quotation.due_at).endOf('day') && !quotation.hasProposal && (
          <>
            <Tooltip title="Imprimir cotação">
              <IconButton size="small" onClick={navigateToPrint}>
                <BsPrinter color="#C4C4C4" size={18} />
              </IconButton>
            </Tooltip>
            {actionsActive && (
              <Tooltip title="Editar cotação">
                <IconButton size="small" onClick={navigate}>
                  <BiMessageSquareEdit color="#C4C4C4" size={19} />
                </IconButton>
              </Tooltip>
            )}
          </>
        )}
      </Cell>
    </Container>
  );
}

export default QuotationItem;
